<template>
    <div class="tasks-page-wrapper">
        <div class="container-fluid">
            <div class="row mt-2 mb-2">
                <div class="col-md-12">
                    <h2 class="text-center">Gerenciamento de Tarefas</h2>
                </div>
            </div>
        </div>
        <TasksManager ref="tasksManager" />
    </div>
</template>

<script>
import TasksManager from './TasksManager.vue';

export default {
    name: 'TasksPage',
    components: { TasksManager },
    mounted() {
        if (location.pathname === '/task_manager') changeTVMode("full");
        this.setupBroadcast();
    },
    beforeDestroy() {
        this.teardownBroadcast();
    },
    methods: {
        setupBroadcast() {
            if (!window.Echo) return;
            const userId = user.getIdPrefix();
            window.Echo.channel(`tasks.user.${userId}`)
                .listen('.task.created', (task) => {
                    this.$refs.tasksManager?.onTaskCreated(task);
                })
                .listen('.task.updated', (task) => {
                    this.$refs.tasksManager?.onTaskUpdated(task);
                })
                .listen('.task.deleted', ({ id }) => {
                    this.$refs.tasksManager?.onTaskDeleted(id);
                });
        },
        teardownBroadcast() {
            if (!window.Echo) return;
            const userId = user.getIdPrefix();
            window.Echo.leave(`tasks.user.${userId}`);
        },
    },
}
</script>

<style scoped>
.tasks-page-wrapper {
    display: flex;
    flex-direction: column;
    padding: 0.4rem 2rem 2rem;
}
</style>
